/*
Copyright (c) 2021
*/

import constants from "../../constants";

const {REQUEST_ADDNEWCLIENT, ADDNEWCLIENT_RECEIVED} = constants.AddNewClientAdminConstants;

export default{
    REQUEST_ADDNEWCLIENT, 
    ADDNEWCLIENT_RECEIVED,

    RequestAddNewClient: payload => ({
        type: REQUEST_ADDNEWCLIENT,
        payload
    }),
    AddNewClientRecieved: () => ({
        type: ADDNEWCLIENT_RECEIVED,
    }),
}